import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Outlet } from 'react-router-dom'
import { checkAuth } from '../../services/auth'
import { APP_URL } from '../../util/constants/APP_URL'

const ProtectedRoute = () => { 
  const dispatch = useDispatch();
  const auth = useSelector((store: any) => store.auth.authenticated);

  useEffect(() => {
    const verifySession = async () => {
      dispatch(checkAuth());
    };

    const interval = setInterval(verifySession, 1000); 
    return () => clearInterval(interval);
  }, [auth]);

  return auth
    ? (
    <Outlet />
      )
    : (
    <Navigate to={APP_URL.AUTHENTICATION.LOGIN} />
      )
}

export default ProtectedRoute
